module.exports = {"data":{"site":{"siteMetadata":{"algolia":{"appId":"1ABU4N544C","searchOnlyApiKey":"44eb42733115ebe1c03bf5fa40b775fb","indexName":"oyabi.fr"}}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/search.json
// module id = 900
// module chunks = 254572558124955